import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { RouteMatcher } from '../../RouteHelpers';
import { IUseAppStatus } from './useAppStatus.types';

export const useAppStatus = () => {
  const location = useLocation();

  return useMemo<IUseAppStatus>(
    () => ({
      isAppWarmingUp: RouteMatcher.isEmpty(location.pathname),
    }),
    [location.pathname],
  );
};
